import React from "react";
import { arrayOf, shape, string } from "prop-types";

import * as S from "./styled";

const LicenseInfo = ({ contacts }) => {
  const businessName = contacts.length ? contacts[0].business_name : null;
  const businessAddress = contacts.length
    ? contacts[0].full_business_address
    : null;

  const renderLicenseText = () => {
    const text = `Listing by ${businessName} ${businessAddress || ""}`;

    if (text.length > 75) {
      return `${text.substring(0, 75)}...`;
    }

    return text;
  };

  return <S.LicenseText>{renderLicenseText()}</S.LicenseText>;
};

LicenseInfo.propTypes = {
  contacts: arrayOf(
    shape({
      id: string,
      business_url: string,
      business_name: string,
      full_business_address: string
    })
  ).isRequired
};

export default LicenseInfo;
